@if (productSection.mappings || productSection.placeholders) {
  <div class="table-scroll-wrapper">
    <table class="navinta-table">
      <thead>
        <tr>
          <th class="col-10" i18n="@@productList.productTable.column1.header" data-testid="productList.productTable.column1">
            Pos.
          </th>
          <th class="col-18" i18n="@@productList.productTable.column2.header" data-testid="productList.productTable.column2">
            Anzahl
          </th>
          <th class="col-auto" i18n="@@productList.productTable.column3.header" data-testid="productList.productTable.column3">
            Bezeichnung
          </th>
          <th class="col-20" i18n="@@productList.productTable.column4.header" data-testid="productList.productTable.column4">
            Sachnummer
          </th>
          <th class="col-15" i18n="@@productList.productTable.column5.header" data-testid="productList.productTable.column5">
            Einzelpreis
          </th>
          <th
            class="col-15"
            i18n="@@productList.productTable.column.discounts"
            data-testid="productList.productTable.column.discounts"
          >
            Rabatt
          </th>
          <th class="col-15" i18n="@@productList.productTable.column6.header" data-testid="productList.productTable.column6">
            Gesamtpreis
          </th>
        </tr>
      </thead>
      @for (mapping of productSection.mappings; track $index) {
        <tbody>
          @for (product of mapping.data; track $index) {
            <tr [ngClass]="{ discontinued: !product.isAvailable, incomplete: product.isIncompleteConfiguration }">
              <td>
                {{ product.positionId + (product.isAvailable || !product.isIncompleteConfiguration ? "" : " ") }}
                @if (!product.isAvailable || product.isIncompleteConfiguration) {
                  <img src="assets/warning-colored-odx.svg" alt="warning" [odxTooltip]="tooltipTextWarningSign" />
                }
              </td>
              <td>{{ mapping.placedProductsCount * product.quantity }}</td>
              <td>{{ product.name }}</td>
              <td>{{ product.id }}</td>
              <td>
                @if (showZrefPrices) {
                  {{
                    !showCosts || !product.zrefPriceData
                      ? ""
                      : (getUnitPrice(product) | currency: product.zrefPriceData.currencyCode)
                  }}
                } @else {
                  {{
                    !showCosts || !product.priceData ? "" : (getUnitPrice(product) | currency: product.priceData!.currencyCode)
                  }}
                }
              </td>
              <td>
                @if (hasEditablePrice(product)) {
                  <div class="product-table__discount-input">
                    <input
                      type="text"
                      inputmode="decimal"
                      [value]="formatDiscount(product.discount ?? 0)"
                      [attr.aria-label]="'Discount ' + product.name"
                      (blur)="normalizeDiscountInput($any($event.target), product)"
                    />
                    <span aria-hidden="true">%</span>
                  </div>
                } @else if (hasPrice(product) && product.discount) {
                  {{ formatDiscount(product.discount) }}%
                } @else if (showCosts && hasPrice(product) && product.discountKey) {
                  -
                }
              </td>
              <td>
                @if (showZrefPrices) {
                  {{
                    !showCosts || !product.zrefPriceData
                      ? ""
                      : (getTotalPrice(product, mapping.placedProductsCount) | currency: product.zrefPriceData.currencyCode)
                  }}
                } @else {
                  {{
                    !showCosts || !product.priceData
                      ? ""
                      : (getTotalPrice(product, mapping.placedProductsCount) | currency: product.priceData!.currencyCode)
                  }}
                }
              </td>
            </tr>
          }
        </tbody>
        <tbody>
          @for (device of productSection.devices; track $index) {
            @for (product of device.products; track $index) {
              @if (product.id && productBelongsToConfig(device, mapping)) {
                <tr>
                  <td>{{ product.positionId }}</td>
                  <td>{{ placeholderWithProductsCount }}</td>
                  <td>{{ product.name || "Benutzerdefinierte Sachnummer" }}</td>
                  <td>{{ product.id }}</td>
                  @if (!showZrefPrices) {
                    <td>
                      {{ !showCosts || !product.price ? "" : (getUnitPrice(product) | currency: product.price.currencyCode) }}
                    </td>
                    <td>
                      @if (hasEditablePrice(product)) {
                        <div class="product-table__discount-input">
                          <input
                            type="text"
                            inputmode="decimal"
                            [value]="formatDiscount(product.discount)"
                            [attr.aria-label]="'Discount ' + product.name"
                            (blur)="normalizeDiscountInput($any($event.target), product)"
                          />
                          <span aria-hidden="true">%</span>
                        </div>
                      } @else if (hasPrice(product) && product.discount) {
                        {{ formatDiscount(product.discount) }}%
                      } @else if (showCosts && hasPrice(product) && product.discountKey) {
                        -
                      }
                    </td>
                    <td>
                      {{
                        !showCosts || !product.price
                          ? ""
                          : (getTotalPrice(product, placeholderWithProductsCount) | currency: product.price.currencyCode)
                      }}
                    </td>
                  }
                </tr>
              }
            }
          }
        </tbody>
      }

      <tbody>
        @for (placeholder of productSection.placeholders; track $index) {
          @for (product of placeholder.products; track $index) {
            @if (product.id) {
              <tr>
                <td>{{ product.positionId }}</td>
                <td>{{ placeholderWithProductsCount }}</td>
                <td>{{ product.name }}</td>
                <td>{{ product.id }}</td>
                @if (!showZrefPrices) {
                  <td>
                    {{ !showCosts || !product.price ? "" : (getUnitPrice(product) | currency: product.price.currencyCode) }}
                  </td>
                  <td>
                    @if (hasEditablePrice(product)) {
                      <div class="product-table__discount-input">
                        <input
                          type="text"
                          inputmode="decimal"
                          [value]="formatDiscount(product.discount)"
                          [attr.aria-label]="'Discount ' + product.name"
                          (blur)="normalizeDiscountInput($any($event.target), product)"
                        />
                        <span aria-hidden="true">%</span>
                      </div>
                    } @else if (hasPrice(product) && product.discount) {
                      {{ formatDiscount(product.discount) }}%
                    } @else if (showCosts && hasPrice(product) && product.discountKey) {
                      -
                    }
                  </td>
                  <td>
                    {{
                      !showCosts || !product.price
                        ? ""
                        : (getTotalPrice(product, placeholderWithProductsCount) | currency: product.price.currencyCode)
                    }}
                  </td>
                }
              </tr>
            }
          }
        }
        @if (placeholderWithoutProductsCount > 0) {
          <tr [ngClass]="{ 'text-red': true }">
            <td>{{ productSection.placeholderPositionPrefix }}</td>
            <td>{{ placeholderWithoutProductsCount }}</td>
            <td i18n="@@productList.placeholder.description">Platzhalter (noch zu konfigurieren)</td>
            <td>{{ "" }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
